<ng-container *ngIf="appropriationOfProfitSection">
    <div class="table-title">
        <ng-container>
            <span class="sectionTitle" stylePreference [textColor]="textColor"> {{ sectionTitle }} </span>
        </ng-container>
        <mat-icon class="edit-icon" (click)="editSectionTitle()" svgIcon="aumico-pattern-icon-edit-write"></mat-icon>
    </div>
    <div [class]="markerClass">
        <div class="appropriation-of-profit">
            <div class="profit-calculation-container">
                <aumico-annualReport-appropriation-of-profit-german-display-component
                    [stylePreferenceOptions]="stylePreferenceOptions"
                    [appropriationOfProfitSection]="appropriationOfProfitSection"
                    [noPreviousData]="noPreviousData"
                >
                </aumico-annualReport-appropriation-of-profit-german-display-component>
            </div>
        </div>
    </div>
</ng-container>
